import React from 'react';
import ReactDOM from 'react-dom/client';
// Удалите или закомментируйте эту строку:
// import './styles.css';
import MillionaireGame from './MillionaireGame';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MillionaireGame />
  </React.StrictMode>
);